// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getExternalNotes} from '../../shared/repositories';

export const readExternalNotes = pin =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const payload = await getExternalNotes(pin);

            dispatch({
                payload,
                property: 'externalNotes',
                type: actions.UPDATE_PRODUCT_DETAILS_EXTERNAL_NOTES
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/external-notes.js